export const isObject = (obj: any) => {
  return obj === Object(obj) && !Array.isArray(obj);
};

export const getSameValueObjectWithKeys = <ValueType>(
  keys: string[],
  value: ValueType,
): { [key: string]: ValueType } => {
  return keys.reduce((acc, key) => ({ ...acc, [key]: value }), {});
};

export const replaceAllValuesOfObject = <ValueType>(
  obj: object,
  newValue: ValueType,
): { [key: string]: ValueType } => {
  return Object.keys(obj).reduce(
    (acc, key) => ({
      ...acc,
      [key]: newValue,
    }),
    {},
  );
};
